import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "pt-10 pb-8 px-8 text-left" }
const _hoisted_2 = { class: "text-xl font-serif-title text-gray-900 font-ivymode font-minerva" }
const _hoisted_3 = { class: "px-8 pb-8 overflow-y-auto text-center" }
const _hoisted_4 = { class: "max-w-4xl mx-auto flex flex-col items-center" }

import {computed, ref} from 'vue';
import {useI18n} from 'vue-i18n';
import AppModal from '@/components/appModal.vue';
import InfoModalStoneType from './infoModalStoneType.vue';
import DiamondDetailClarityContent from "@/components/diamonds/details/DiamondDetailClarityContent.vue";
import DiamondDetailColorContent from "@/components/diamonds/details/DiamondDetailColorContent.vue";
import DiamondDetailCutContent from "@/components/diamonds/details/DiamondDetailCutContent.vue";
import DiamondDetailFluorescenceContent from "@/components/diamonds/details/DiamondDetailFluorescenceContent.vue";
import DiamondDetailCaratContent from "@/components/diamonds/details/DiamondDetailCaratContent.vue";
import InfoModalStonePresets from "@/components/info/infoModalStonePresets.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'infoModal',
  props: {
    id: {},
    value: { default: null },
    additionalValue: { default: '' },
    stoneType: { default: 'earth' }
  },
  setup(__props: any) {

const props = __props;

const finalId = computed(() => {
  const idMap: Record<string, string> = {
    stone_size: 'stoneSize',
    stone_type: 'stoneType',
    stone_quality: 'stonePreset',
  };
  const id = props.id || ""

  return idMap[id] || id;
});


const isOpen = ref(false);

const {t} = useI18n();

const modalTitle = computed(() => {
  if (finalId.value === 'stoneSize') {
    const key = typeof props.value === 'object' && props.value !== null ? 'stoneSizeSelection' : 'stoneSize';
    return t(`components.infoModal.titles.${key}`);
  }
  return t(`components.infoModal.titles.${finalId.value}`, t('components.infoModal.titles.information'));
});

const supportedModals = ['stoneClarity', 'stoneColor', 'stoneCut', 'stoneFluorescence', 'stoneSize', 'stoneType', 'stonePreset'];

const isSupported = computed(() => {
  if (props.additionalValue !== '' && finalId.value == 'stone_quality') {
    return parseFloat(props.additionalValue) >= 0.3;
  }
  return supportedModals.includes(finalId.value)
});

const toggleModal = () => {
  if (isSupported.value) {
    isOpen.value = !isOpen.value;
  }
};


return (_ctx: any,_cache: any) => {
  return (isSupported.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "inline-block align-middle my-auto",
        onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createElementVNode("div", {
          class: "cursor-pointer ml-1 flex items-center justify-center text-brand-main hover:text-gray-600 transition-colors",
          onClick: toggleModal
        }, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            class: "size-4",
            fill: "none",
            viewBox: "0 0 24 24",
            stroke: "currentColor",
            "stroke-width": "2"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            })
          ], -1)
        ]))]),
        _createVNode(AppModal, {
          modelValue: isOpen.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((isOpen).value = $event)),
          label: modalTitle.value,
          duration: 300
        }, {
          default: _withCtx(() => [
            _createVNode(_Transition, { name: "fade" }, {
              default: _withCtx(() => [
                (isOpen.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "fixed inset-0 z-1000 flex items-start justify-center p-4 sm:p-6 bg-black/20 backdrop-blur-xs",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (isOpen.value = false))
                    }, [
                      _createVNode(_Transition, {
                        name: "modal-pop",
                        appear: ""
                      }, {
                        default: _withCtx(() => [
                          (isOpen.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "bg-white rounded-[2.5rem] shadow-2xl max-w-xl w-full max-h-[90vh] overflow-y-auto flex flex-col relative",
                                onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                              }, [
                                _createElementVNode("button", {
                                  type: "button",
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = false)),
                                  class: "absolute top-4 right-4 z-10 w-8 h-8 flex items-center justify-center text-white bg-brand-main hover:bg-gray-400 transition-colors rounded-full shadow-sm"
                                }, [...(_cache[6] || (_cache[6] = [
                                  _createElementVNode("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    "stroke-width": "3",
                                    stroke: "currentColor",
                                    class: "size-6"
                                  }, [
                                    _createElementVNode("path", {
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                      d: "M6 18L18 6M6 6l12 12"
                                    })
                                  ], -1)
                                ]))]),
                                _createElementVNode("div", _hoisted_1, [
                                  _createElementVNode("h3", _hoisted_2, _toDisplayString(modalTitle.value), 1)
                                ]),
                                _createElementVNode("div", _hoisted_3, [
                                  _createElementVNode("div", _hoisted_4, [
                                    (finalId.value === 'stoneClarity')
                                      ? (_openBlock(), _createBlock(DiamondDetailClarityContent, {
                                          key: 0,
                                          clarity: __props.value,
                                          "mobile-mode": ""
                                        }, {
                                          title: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                            _createElementVNode("span", null, null, -1)
                                          ]))]),
                                          _: 1
                                        }, 8, ["clarity"]))
                                      : _createCommentVNode("", true),
                                    (finalId.value === 'stoneColor')
                                      ? (_openBlock(), _createBlock(DiamondDetailColorContent, {
                                          key: 1,
                                          color: __props.value,
                                          "mobile-mode": ""
                                        }, {
                                          title: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                            _createElementVNode("span", null, null, -1)
                                          ]))]),
                                          _: 1
                                        }, 8, ["color"]))
                                      : _createCommentVNode("", true),
                                    (finalId.value === 'stoneCut')
                                      ? (_openBlock(), _createBlock(DiamondDetailCutContent, {
                                          key: 2,
                                          cut: __props.value,
                                          "stone-type": __props.stoneType,
                                          "mobile-mode": ""
                                        }, {
                                          title: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                            _createElementVNode("span", null, null, -1)
                                          ]))]),
                                          _: 1
                                        }, 8, ["cut", "stone-type"]))
                                      : _createCommentVNode("", true),
                                    (finalId.value === 'stoneFluorescence')
                                      ? (_openBlock(), _createBlock(DiamondDetailFluorescenceContent, {
                                          key: 3,
                                          fluorescence: __props.value,
                                          "mobile-mode": ""
                                        }, {
                                          title: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                            _createElementVNode("span", null, null, -1)
                                          ]))]),
                                          _: 1
                                        }, 8, ["fluorescence"]))
                                      : _createCommentVNode("", true),
                                    (finalId.value === 'stoneSize')
                                      ? (_openBlock(), _createBlock(DiamondDetailCaratContent, {
                                          key: 4,
                                          carat: __props.value,
                                          "mobile-mode": ""
                                        }, {
                                          title: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                            _createElementVNode("span", null, null, -1)
                                          ]))]),
                                          _: 1
                                        }, 8, ["carat"]))
                                      : _createCommentVNode("", true),
                                    (finalId.value === 'stoneType')
                                      ? (_openBlock(), _createBlock(InfoModalStoneType, {
                                          key: 5,
                                          value: __props.value
                                        }, null, 8, ["value"]))
                                      : _createCommentVNode("", true),
                                    (finalId.value === 'stonePreset')
                                      ? (_openBlock(), _createBlock(InfoModalStonePresets, {
                                          key: 6,
                                          value: __props.stoneType
                                        }, null, 8, ["value"]))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "label"])
      ]))
    : _createCommentVNode("", true)
}
}

})